import SentimentAngry from '@/images/sentiment/SentimentAngry.svg';
import SentimentEmpathetic from '@/images/sentiment/SentimentEmpathetic.svg';
import SentimentExcited from '@/images/sentiment/SentimentExcited.svg';
import SentimentFriendly from '@/images/sentiment/SentimentFriendly.svg';
import SentimentProfessional from '@/images/sentiment/SentimentProfessional.svg';
import { AvatarSentiment, IExpressiveSentiment, IVoice, Presenter, VoiceAccess } from '@d-id/types';

export const getVoiceFromCurrentSentiment = (selectedSentimentId?: string, avatar?: Presenter): IVoice | null => {
    const sentiments = avatar?.sentiments;
    if (!avatar || !sentiments?.length) return null;

    const sentiment = sentiments.find(sentiment => sentiment.id === selectedSentimentId) || sentiments[0];

    if (!sentiment?.voice) return null;

    return {
        id: sentiment.voice.voice_id,
        name: avatar.name,
        gender: '',
        access: VoiceAccess.Private,
        provider: sentiment.voice?.type,
        styles: [],
        language: 'multilingual',
        locale: 'en-US',
        voiceType: 'Injected',
    };
};

export const getDefautlVoiceForExpressiveAvatar = (avatar?: Presenter): IVoice | null => {
    const sentiment = avatar?.sentiments?.[0]?.sentiment;
    if (!sentiment) return null;

    return getVoiceFromCurrentSentiment(sentiment, avatar);
};

export const SENTIMENT_ORDER: AvatarSentiment[] = [
    AvatarSentiment.Friendly,
    AvatarSentiment.Professional,
    AvatarSentiment.Empathetic,
    AvatarSentiment.Excited,
    AvatarSentiment.Frustrated,
];

export const sentimentImageSources: Record<AvatarSentiment, string> = {
    [AvatarSentiment.Friendly]: SentimentFriendly,
    [AvatarSentiment.Professional]: SentimentProfessional,
    [AvatarSentiment.Empathetic]: SentimentEmpathetic,
    [AvatarSentiment.Excited]: SentimentExcited,
    [AvatarSentiment.Frustrated]: SentimentAngry,
};

export const sortSentiments = (sentiments: IExpressiveSentiment[]) => {
    if (!sentiments.length) {
        return sentiments;
    }

    return [...sentiments].sort((a, b) => {
        const aIndex = SENTIMENT_ORDER.indexOf(a.sentiment);
        const bIndex = SENTIMENT_ORDER.indexOf(b.sentiment);

        // If sentiment not found in order array, put it at the end
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;

        return aIndex - bIndex;
    });
};
